import { cardsItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门文章
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选深度好文，带你全方位吃瓜
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsItems.map((item, i) => (
            <article key={i} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.reads} 阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}